import React from 'react';
import { ReactComponent as CheckIcon } from '../../assets/icons/check-icon.svg';
import { ReactComponent as CloseIcon } from '../../assets/icons/x-icon.svg';
import { ReactComponent as EditIcon } from '../../assets/icons/edit-icon.svg';
const FORM_PADDING = { padding: '8px' };

function ConfirmCancel({ onConfirm, onCancel }) {
  return (
    <span style={{ display: 'inline-flex', gap: 4, alignItems: 'center', flexShrink: 0 }}>
      <div className="primary-icon-button" onClick={onConfirm}>
        <CheckIcon width={20} height={20} style={{ margin: 'auto' }} />
      </div>
      <div className="cancel-icon-button" onClick={onCancel}>
        <CloseIcon width={16} height={16} style={{ margin: 'auto' }} />
      </div>
    </span>
  );
}

/** Standalone edit/confirm/cancel buttons when controls must live outside the input container. */
export function EditableCellActions({ isEditing, onEdit, onConfirm, onCancel }) {
  return isEditing
    ? <ConfirmCancel onConfirm={onConfirm} onCancel={onCancel} />
    : <EditIcon width={18} height={18} color="#7CC805" onClick={onEdit} style={{ cursor: 'pointer' }} />;
}

/**
 * Inline editable cell with view / edit modes.
 * `variant='form'` renders as a full bordered form field for use in form-group layouts.
 * `showControls=false` hides icons (for cells that share controls with a sibling).
 */
export default function EditableCell({
  value,
  isEditing,
  onChange,
  onEdit,
  onConfirm,
  onCancel,
  type = 'number',
  renderValue,
  showControls = true,
  editingContainerStyle,
  displayContainerStyle,
  variant = 'cell',
  inputProps,
}) {
  const isForm = variant === 'form';
  const editingStyle = { ...(FORM_PADDING), ...editingContainerStyle };
  const displayStyle = { ...(isForm ? FORM_PADDING : { maxWidth: 150 }), ...displayContainerStyle };

  if (isEditing) {
    const inputStyle = {
      flex: 1, border: 0, outline: 'none', fontSize: 14, backgroundColor: '#fff',
    };
    return (
      <div className="form-input" style={{ display: 'flex', padding: "8px", alignItems: 'center', gap: 2, ...editingStyle }}>
        {/* {type === 'date'
          ? <DateInput value={value} onChange={onChange} className="date-input" style={inputStyle} />
          : <input type={type === 'number' ? 'number' : 'text'} value={value ?? ''} onChange={onChange} style={inputStyle} />} */}
        <input type={type} value={value ?? ''} onChange={onChange} style={inputStyle} {...inputProps} />
        {showControls && <ConfirmCancel onConfirm={onConfirm} onCancel={onCancel} />}
      </div>
    );
  }

  const display = renderValue ? renderValue(value) : value;
  if (!showControls) return <span>{display}</span>;

  return (
    <div
      className={isForm ? 'form-input' : undefined}
      style={{ display: 'flex', alignItems: 'center', gap: 8, whiteSpace: 'nowrap', justifyContent: 'space-between', ...displayStyle }}
    >
      {display}
      <EditIcon width={18} color="#7CC805" onClick={onEdit} style={{ marginLeft: 'auto', cursor: 'pointer', flexShrink: 0 }} />
    </div>
  );
}
